import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivate } from '@angular/router';

export interface CanDeactivateComponent {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuardService implements CanDeactivate<CanDeactivateComponent> {

  canDeactivate(component: CanDeactivateComponent) {
    if (!component || !component.canDeactivate || component.canDeactivate()) {
      return true;
    } else {
      return window.confirm('You Have Unsaved Changes. Press Cancel to go back and Save Changes, or Ok to lose the changes.');
    }
  }
}
